module.exports = __webpack_public_path__ + "img/img07.6f2df5ce.jpeg";